export const containsIgnoreCase = (value: string, search: string) => value.toLowerCase().includes(search.toLowerCase())
